
























































































import * as Sentry from '@sentry/browser';
import { Component, Prop, Vue } from 'vue-property-decorator';

// Components
import Alert from '@/components/Global/Alert.vue';
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import PoliciesTable from './PoliciesTable.vue';

// Services
import Brand from '@/services/Brand';
import Staff from '@/services/Staff';
import { Brands } from '@/common/Policy';
import { BrandedPolicyDetails, PolicyDetails } from '@/common/Users';

@Component({
	name: 'TabPolicies',
	components: {
		Alert,
		PoliciesTable,
		SelectField,
		TextField,
	},
})
export default class TabPolicies extends Vue {
	@Prop() private user: any;

	private newPolicy: {
		policy_number: string;
		client_id: string;
		brand: Brands | '';
	} = {
		policy_number: '',
		client_id: '',
		brand: '',
	};
	private policyError: boolean | string = false;

	get orgAdminPolicies(): BrandedPolicyDetails[] {
		return (this.user?.org_admin_policies ?? []).map(
			(policyDetails: PolicyDetails): BrandedPolicyDetails => ({
				...policyDetails,
				brand: this.user?.org_admin_brand,
			}),
		);
	}

	get userPolicies(): BrandedPolicyDetails[] {
		return Object.entries(this.user?.policies ?? {})
			.map(([brand, policies]: [Brands, PolicyDetails[]]): BrandedPolicyDetails[] => {
				return policies.map(
					(policyDetails: PolicyDetails): BrandedPolicyDetails => ({
						...policyDetails,
						brand,
					}),
				);
			})
			.flat();
	}

	/**
	 * Save policy to user
	 */
	private async savePolicyToUser() {
		this.policyError = false;

		const hasReportsAccess: boolean = this.user.permissions[Brand.getBrand()].VIEW_REPORTS;
		if (
			this.newPolicy.policy_number &&
			!this.newPolicy.client_id &&
			this.newPolicy.brand === 'mmic' &&
			hasReportsAccess
		) {
			this.policyError =
				'Policy Number and Client Id are required for the user who has access to Loss History/Credential Reports !';
			return;
		}

		for (const policy of this.userPolicies) {
			if (
				policy.policy_number === this.newPolicy.policy_number &&
				policy.brand === this.newPolicy.brand
			) {
				this.policyError = 'Policy Number/Client Id already added!';
				return;
			}
		}

		try {
			const sendData = {
				cmd: 'new_policy' as const,
				policy: this.newPolicy as BrandedPolicyDetails,
				org_id: this.user.org_id,
				sub: this.user.sub,
			};
			const updateData = await Staff.updateUser(sendData);

			if ('error' in updateData.data) {
				this.policyError = updateData.data.error;
				return;
			}

			this.newPolicy = {
				policy_number: '',
				client_id: '',
				brand: '',
			};

			this.user.policies = updateData.data.policies;
		} catch (e) {
			Sentry.captureException(e);
			this.policyError = 'There was an error adding the policy.';
		}
	}

	/**
	 * Save policy to user
	 */
	private async deletePolicyToUser(policy: BrandedPolicyDetails): Promise<void> {
		this.policyError = false;

		try {
			const sendData = {
				cmd: 'delete_policy' as const,
				policy,
				sub: this.user.sub,
			};
			const deletePolicy = await Staff.updateUser(sendData);
			if (deletePolicy.data.deleted) {
				this.user.policies = deletePolicy.data.policies;
			}
		} catch (e) {
			Sentry.captureException(e);
			this.policyError = 'There was an error disassociating the policy.';
		}
	}

	private changeBrand($event) {
		this.newPolicy.brand = $event.target.value;
	}
}
